import React, { useEffect } from "react";
import DashBoardMobileServiceUsers from "../../components/DashBoard/DashBoardMobile/DashBoardMobileServiceUsers";
import { useTripsCtx } from "../../context/TripDetailsContext";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";

const ProfileMobileServiceUsersContainer = () => {
  const {
    handleManageServiceUsersData,
    serviceDataCtx,
  } = useTripsCtx();
  const { isLoadingPersonData } = usePersonSummaryCtx();

  useEffect(() => {
    !isLoadingPersonData &&
      !serviceDataCtx[0].length &&
      handleManageServiceUsersData();
  }, [isLoadingPersonData]);

  return <DashBoardMobileServiceUsers />;
};
export default ProfileMobileServiceUsersContainer;
